import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../../components/Navbar";
import Subnav from "../SubNav";
import Footer from "../../../components/Footer";
import SaleReturn from "./SaleReturns";

export default function SaleReturnsPage() {
  const { id } = useParams(); // get /sales/:id
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <Subnav />
      <div className="min-h-screen bg-gray-50">
        <SaleReturn
          saleId={id}
          onBack={() => navigate(-1)} // go back
        />
      </div>
      <Footer />
    </div>
  );
}
